import React, {useEffect, useState} from 'react'

import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import {Link} from "react-router-dom";

const initialUser = {
    name: '',
    email: '',
    contactNumber: '',
    street: '',
    suburb: '',
    city: '',
    subRows: undefined,
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const { addUserHandler } = props
    const [open, setOpen] = React.useState(false)
    const [addButton, setAddButton] = useState(false)

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({ ...switchState, [name]: event.target.checked })
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        props.history.push('/add-policy-holder');
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({target: {value}}) => {
        setUser({...user, [name]: value})
    }

    useEffect(() => {
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setAddButton(false);

        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'add policy holder') {
                    setAddButton(true);
                }

            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setAddButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'add policy holder') {
                    setAddButton(true);
                }
            })
        }
    }, [])

    return (
        <div>
            {addButton && (
                <Tooltip title="New Record">
                    <Link to={'/add-policy-holder'}>
                        <span className="btn btn-sm btn-primary mr-5"><i className="fa fa-plus-square"/> &nbsp;&nbsp;Add Policy Holder</span>
                    </Link>
                </Tooltip>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add New Policy Holder</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        value={user.name}
                        onChange={handleChange('name')}
                    />
                    <TextField
                        margin="dense"
                        label="Email"
                        type="text"
                        fullWidth
                        value={user.email}
                        onChange={handleChange('email')}
                    />

                    <TextField
                        margin="dense"
                        label="Contact Number"
                        type="text"
                        fullWidth
                        value={user.contactNumber}
                        onChange={handleChange('contactNumber')}
                    />
                    <TextField
                        margin="dense"
                        label="Street"
                        type="text"
                        fullWidth
                        value={user.street}
                        onChange={handleChange('street')}
                    />
                    <TextField
                        margin="dense"
                        label="Suburb"
                        type="text"
                        fullWidth
                        value={user.suburb}
                        onChange={handleChange('suburb')}
                    />
                    <TextField
                        margin="dense"
                        label="City"
                        type="text"
                        fullWidth
                        value={user.city}
                        onChange={handleChange('city')}
                    />
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
